/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BasePOCOMongoEntity } from './basePOCOMongoEntity';
import { EntityStatus } from './entityStatus';


export interface PartnerModel extends BasePOCOMongoEntity { 
    id: string;
    returnId?: string;
    partnerId: number;
    spId?: string;
    companyName?: string;
    businessDescription?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
    isActive: boolean;
    isDeleted: boolean;
}
